import styled from 'styled-components';

const RecruitFlag = ({ title }: any) => {
  return (
    <>
      <RecruitFlagDiv>
        <RecruitFlagText className="b2">{title}</RecruitFlagText>
      </RecruitFlagDiv>
    </>
  );
};

export default RecruitFlag;

const RecruitFlagDiv = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  padding: 1rem;
  border-radius: 10rem;
  background: var(--primary-1-opacity-50);
`;

const RecruitFlagText = styled.p`
  color: var(--primary-ivy-green-600);
  padding: 0rem 0.6rem;
`;
